import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import '../Iniciativas.scss';
import './ComunicacaoInterna.scss';

class ComunicacaoInterna extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 'mulher',
      mobile: window.innerWidth < 768 ? true : false,
    };

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();

    // if (this.state.mobile == true) {
    // 	this.mobileNav();
    // }
  };

  mobileNav = () => {};

  changeItem = () => {
    const { selected } = this.state;
    this.setState({
      selected: selected == 'mulher' ? 'homem' : 'mulher',
    });
  };

  render = () => {
    const { selected } = this.state;
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Comunicação Interna - Iniciativas - {texts.title}</title>
        </Helmet>

        <div
          className="iniciativas-home treinamentos-home page-gradient page-gradient--yellow bg-gray bg-programa-de-supervisao"
          ref="treinamentos-home"
        >
          <section className="iniciativas-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className={`card card--page-body card--light-blue`}>
                      <div className="card__content">
                        <div className="card__content__header after-header-programa-de-supervisao">
                          <DelayLink
                            to={`/estrategias/dentro-de-casa`}
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray titulo-programa-de-supervisao">
                            COMUNICAÇÃO INTERNA GANHA REFORÇO
                            <span className="gri-comunicacao-interna">
                              GRI <b>102-43</b>
                            </span>
                          </h1>
                        </div>
                        <div className="texto-e-imagem-hero-comunicacao-interna">
                          <p>
                            Estratégica durante a pandemia, quando os colaboradores migraram totalmente para o trabalho
                            remoto, a comunicação interna avançou muito em 2020. Com o objetivo tanto de informar quanto
                            de cuidar, engajar e motivar a equipe, aumentamos substancialmente o volume de posts na
                            intranet, inovamos nos formatos e no uso de soluções on e offline para passar os recados.
                            Entre as principais iniciativas, destacam-se:
                          </p>
                          <img src={images.comunicacao_interna.img_hero_comunicacao_interna} />
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="iniciativas-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="box-2-comunicacao-interna">
                      <div className="box-2-conteudo">
                        <img src={images.comunicacao_interna.box_2_imagem_1} alt="Check-in" />
                        <h2>Check-in</h2>
                        <p>
                          Série de lives realizadas às segundas-feiras, sempre no formato de entrevistas, abordando
                          temas de interesse dos funcionários. Vários superintendentes e gerentes ocuparam os microfones
                          dando updates sobre o que estava acontecendo em suas respectivas áreas e tirando dúvidas ao
                          vivo. Entre os entrevistados, também tivemos especialistas das áreas de saúde, bem-estar e
                          inovação.
                        </p>
                      </div>
                      <div className="box-2-conteudo">
                        <img
                          src={images.comunicacao_interna.box_2_imagem_2}
                          alt="Campanha de retorno aos escritórios"
                        />
                        <h2>Campanha de retorno aos escritórios</h2>
                        <p>
                          A volta gradativa aos escritórios, ocorrida a partir de agosto, envolveu uma ampla campanha de
                          comunicação, com a produção de adesivos, folders e publicações quase que diárias na intranet
                          para manter todos muito bem informados.
                        </p>
                      </div>
                      <div className="box-2-conteudo">
                        <img src={images.comunicacao_interna.box_2_imagem_3} alt="De bem com a vida" />
                        <h2>De bem com a vida</h2>
                        <p>
                          O programa voltado ao bem-estar dos funcionários teve na intranet uma importante aliada em
                          2020. Por lá, os funcionários foram envolvidos em jogos e treinos funcionais online, e
                          realizamos lives diversas sobre temas de interesse, relacionados ou não à pandemia.
                        </p>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="iniciativas-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="box-3-comunicacao-interna">
                      <p>
                        O volume de posts na intranet cresceu substancialmente, não só para informar sobre todas as
                        mudanças que ocorriam como para garantir uma comunicação uniforme. Ao longo de 2020, foram mais
                        de 1.078 publicações, 36.516 reações e 7.423 comentários.
                      </p>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { ComunicacaoInterna };
